export const Reports = [{
  label: 'Sales',
  value: 'sales'
}, {
  label: 'Evaluations',
  value: 'evaluations'
}, {
  label: 'Feedback',
  value: 'feedback'
}, {
  label: 'Cloud conversions',
  value: 'conversions'
}, {
  label: 'Cloud renewals',
  value: 'renewals'
}, {
  label: 'Cloud churn',
  value: 'churn'
}, {
  label: 'Transactions',
  value: 'transactions'
}, {
  label: 'Licenses',
  value: 'licenses'
}, {
  label: 'Feedback details',
  value: 'feedback-details'
}, {
  label: 'Date API',
  value: ''
}];
export const DateRange = [{
  label: 'All dates',
  value: undefined
}, {
  label: 'Last 30 days',
  value: 'past30Days'
}, {
  label: 'Last 90 days',
  value: 'past90Days'
}, {
  label: 'This month to date',
  value: 'thisMonth'
}, {
  label: 'Last month',
  value: 'lastMonth'
}, {
  label: 'Year to date',
  value: 'thisYear'
}, {
  label: 'Last year',
  value: 'lastYear'
}, {
  label: 'Custom',
  value: 'custom'
}];
export const SalesBy = [{
  label: 'All',
  value: undefined
}, {
  label: 'Hosting',
  value: 'hosting'
}, {
  label: 'Sale type',
  value: 'type'
}, {
  label: 'Region',
  value: 'region'
}, {
  label: 'Country',
  value: 'country'
}];
export const EvaluationsBy = [{
  label: 'All',
  value: undefined
}, {
  label: 'Hosting',
  value: 'hosting'
}, {
  label: 'Region',
  value: 'region'
}, {
  label: 'Country',
  value: 'country'
}];
export const FeedbackBy = [{
  label: 'Reason',
  value: undefined
}, {
  label: 'Type',
  value: 'type'
}];
export const FeedbackSource = [{
  label: 'New cloud reasons',
  value: undefined
}, {
  label: 'Manage apps',
  value: 'manageApps'
}, {
  label: 'Admin hub',
  value: 'adminHub'
}];
export const LicenseStatus = [{
  label: 'All',
  value: undefined
}, {
  label: 'Active',
  value: 'active'
}, {
  label: 'Expired',
  value: 'inactive'
}, {
  label: 'Cancelled',
  value: 'cancelled'
}];
export const LicenseType = [{
  label: 'All',
  value: undefined
}, {
  label: 'Evaluation',
  value: 'evaluation'
}, {
  label: 'Paid',
  value: ['commercial', 'academic']
}, {
  label: 'Free',
  value: ['community', 'demonstration', 'open_source']
}];
export const Hosting = [{
  label: 'All',
  value: undefined
}, {
  label: 'Cloud',
  value: 'cloud'
}, {
  label: 'Server',
  value: 'server'
}, {
  label: 'Data center',
  value: 'datacenter'
}];
export const SaleType = [{
  label: 'All',
  value: undefined
}, {
  label: 'New',
  value: 'new'
}, {
  label: 'Renewal',
  value: 'renewal'
}, {
  label: 'Upgrade',
  value: 'upgrade'
}, {
  label: 'Refund',
  value: 'refund'
}];
export const SaleChannel = [{
  label: 'All',
  value: undefined
}, {
  label: 'Expert',
  value: 'expert'
}, {
  label: 'Reseller',
  value: 'reseller'
}, {
  label: 'Direct',
  value: 'direct'
}];
export const Action = [{
  label: 'All',
  value: undefined
}, {
  label: 'Uninstalled',
  value: 'uninstall'
}, {
  label: 'Disabled',
  value: 'disable'
}, {
  label: 'Unsubscribed',
  value: 'unsubscribe'
}];
export const Author = [{
  label: 'All',
  value: undefined
}, {
  label: 'Anonymous',
  value: 'anonymous'
}, {
  label: 'Known',
  value: 'known'
}];
export const TypeOfLicensesData = [{
  label: 'Default',
  value: undefined
}, {
  label: 'With additional insights',
  value: 'true'
}];
export const BaseResultsOn = [{
  label: 'License start dates',
  value: undefined
}, {
  label: 'License end dates',
  value: 'end'
}];
export const FeedbackReasons = [{
  label: 'All reasons',
  value: undefined
}, {
  label: 'App functionality',
  value: 'appFunctionality'
}, {
  label: 'App is expensive',
  value: 'expensive'
}, {
  label: 'We are moving to another cloud platform',
  value: 'migrate'
}, {
  label: 'I found a better alternative for this app',
  value: 'alternative'
}, {
  label: 'Customer support',
  value: 'customerSupport'
}, {
  label: 'The app did not meet my expectations',
  value: 'expectations'
}, {
  label: 'App design',
  value: 'appDesign'
}, {
  label: 'Other',
  value: 'other'
}];